import type { AdaptiveColor } from './AdaptiveColor';
import type { Color } from './Color';
import { ColorMode } from './ColorMode';
import type { IColor } from './IColor';

export class ForegroundColor implements IColor {
  private _color: IColor;
  private _light?: Color;
  private _dark?: Color;

  constructor(color: IColor) {
    this._color = color;
  }

  realize(mode: ColorMode): Color {
    return mode === ColorMode.LIGHT ? this.light : this.dark;
  }

  get color(): IColor {
    return this._color;
  }

  get light(): Color {
    if (!this._light) {
      this._light = this._color.realize(ColorMode.LIGHT).textColor;
    }
    return this._light;
  }

  get dark(): Color {
    if (!this._dark) {
      this._dark = this._color.realize(ColorMode.DARK).textColor;
    }
    return this._dark;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  lerp(t: number, end: IColor): AdaptiveColor {
    throw new Error('Cannot interpolate unrealized foreground color');
  }

  toJSON(): unknown {
    const innerJson = this._color.toJSON();
    // IColor.toJSON() returns either a string (for named colors/hex) or an object (for complex adaptive colors)
    // For strings, we concatenate directly: "fg-red", "fg-#FF0000", "fg-adaptive-blue"
    // For objects, we need to stringify: "fg-{...}"
    if (typeof innerJson === 'string') {
      return `fg-${innerJson}`;
    } else {
      return `fg-${JSON.stringify(innerJson)}`;
    }
  }
}
